
import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/language";

export function SignInPrompt() {
  const { language } = useLanguage();
  
  return (
    <div className="bg-muted/50 rounded-lg p-6 text-center my-8">
      <h3 className="text-xl font-semibold mb-3">
        {language === 'ja' ? 'サインインして統計情報を見る' : 'Sign in to view your statistics'}
      </h3>
      <p className="text-muted-foreground mb-4">
        {language === 'ja' 
          ? 'サインインすると、あなたの赤ちゃんの成長データと家族情報をクラウドに保存し、どのデバイスでも閲覧できます。' 
          : 'Sign in to save your baby\'s growth data and family information to the cloud, accessible from any device.'}
      </p>
      <Link to="/login">
        <Button className="mt-2">
          <LogIn className="w-4 h-4 mr-2" />
          {language === 'ja' ? 'サインイン' : 'Sign In'}
        </Button>
      </Link>
    </div>
  );
}
